module.exports = __webpack_public_path__ + "static/media/dentalrootcanal01.0ba1775b.png";